<template>
  <div>
    <el-card>
      <div slot="header">
        <span>登录日志</span>
      </div>
      <div>这里后续实现登录日志查询与查看功能。</div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'AdminLoginLog'
}
</script>